import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { LazyIconCircle } from '@/design-system/atoms/Icons/IconCircle/Lazy';
import Typography from '@/design-system/atoms/Typography';

import styles from './Status.module.scss';

/**
 * Optional Card Status Component
 * @param {object} props
 * @param {object} props.ref - React ref object
 * @param {string} props.className - Additional class name
 * @param {string} props.label - Status label
 * @param {boolean} props.isActive - Is status active
 * @returns {React.ReactElement}
 */
export const Status = React.forwardRef((props, ref) => {
    const { className, isActive, label, ...otherProps } = props;

    return (
        <div ref={ref} className={classnames(styles['status'], className)} {...otherProps}>
            <LazyIconCircle
                className={classnames(
                    styles['status__icon'],
                    styles[`status__icon--${isActive ? 'active' : 'inactive'}`],
                )}
            />
            <Typography variant="t4" content={label} lineClamp={{ sm: 1, lg: 1 }} />
        </div>
    );
});

Status.displayName = 'Status';

Status.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
    label: PropTypes.string,
};

export default Status;
